<template>
    <div class="a-loader-h2h">
        <svg
            class="loader__spinner"
            viewBox="0 0 16 16"
        >
            <path
                fill="#9E9EB4"
                d="M16 8a8 8 0 11-3.6-6.7l-1.6 2.5A5 5 0 1013 8h3z"
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'ALoaderAc'
};
</script>

<style lang="scss" src="./a-loader-h2h.scss" />
